import { Icon } from 'gu-ui-kit'
import React from 'react'

export default () => {
  return {
    initial: {
      query: '',
      statuses: ['pending', 'working'],
    },
    configuration: {
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'tickets::filters.dropdown.items.query.label',
        placeholder: 'tickets::filters.input.placeholder',
        order: 1,
        type: 'input',
      },
      statuses: {
        order: 2,
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'Accent-Notice-Primary'}
            color={'Label-Onsurface'}
          />
        ),
        label: 'tickets::filters.dropdown.items.statuses.label',
        type: 'select',
        multiple: true,
        optionLabelPrefix: 'tickets::filters.dropdown.items.statuses.options.',
        options: ['pending', 'working', 'closed'],
      },
    },
  }
}
